















































import { Component, Vue } from 'vue-property-decorator';

import { Report as terms, Other as otherTerms } from '@/const/terms/mainTerms';
import { ComponentTerms as compTerms } from '@/const/terms/componentTerms';

import { ISearchFormType } from './types';

import Select from '@/components/ElementComponent/Select/index.vue';
import CalendarForAI from '@/components/pages/report/ai/CalendarForAI.vue';

@Component<ReportAI>({
    name: 'ReportAI',
    components: {
        Select,
        CalendarForAI,
    },
})
export default class ReportAI extends Vue {
    private terms = terms;
    private compTerms = compTerms;

    private loading: boolean = false;
    private subLoading: boolean = false;
    private isUtilsCollapsed: boolean = false;
    private showOption: string[] = [otherTerms.request, otherTerms.impression, otherTerms.impRate];
    private checkOptions: string[] = [otherTerms.request, otherTerms.impression, otherTerms.impRate];
    private month: Date | string= new Date();

    private appOptions: { value: string; label: string }[] = [];
    private inventoryOptions: { value: string; label: string }[] = [];
    private model: ISearchFormType = { app: '', placement: '' };

    private toggleUtilCollapsed() {
        this.isUtilsCollapsed = !this.isUtilsCollapsed;
    }
}
